// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PaymentList_dexPanel_3dkzk{padding:.875rem;border-radius:.625rem;background-color:color-mix(in srgb,var(--legend-c-bg) 50%,transparent);margin-bottom:.875rem}", ""]);
// Exports
exports.locals = {
	"dexPanel": "PaymentList_dexPanel_3dkzk"
};
module.exports = exports;
